import React, { useState } from 'react';
import {
  View, Text, ScrollView, TouchableOpacity,
  StyleSheet, Alert, TextInput,
} from 'react-native';

const CATEGORIA_LABEL = {
  carro: '🚗 Carro', van: '🚐 Van', caminhao_b: '🚚 Caminhão B',
};

export default function VehicleDetailScreen({ route, navigation }) {
  const { veiculo, origem, destino, data: dataParam } = route.params;

  const [dataInicio, setDataInicio] = useState(dataParam ? formatBR(dataParam) : '');
  const [dataFim,    setDataFim]    = useState('');

  function formatBR(iso) {
    if (!iso) return '';
    const [a, m, d] = iso.split('-');
    return `${d}/${m}/${a}`;
  }

  function parseToISO(dataBR) {
    if (!dataBR || dataBR.length < 8) return '';
    const [d, m, a] = dataBR.split('/');
    return a && m && d ? `${a}-${m}-${d}` : '';
  }

  function formatarData(texto) {
    const nums = texto.replace(/\D/g, '');
    if (nums.length <= 2) return nums;
    if (nums.length <= 4) return `${nums.slice(0,2)}/${nums.slice(2)}`;
    return `${nums.slice(0,2)}/${nums.slice(2,4)}/${nums.slice(4,8)}`;
  }

  function calcDias() {
    const ini = parseToISO(dataInicio);
    const fim = parseToISO(dataFim);
    if (!ini || !fim) return 0;
    const diff = (new Date(fim) - new Date(ini)) / (1000 * 60 * 60 * 24);
    return Math.max(0, Math.ceil(diff));
  }

  const dias        = calcDias();
  const precoTotal  = dias * parseFloat(veiculo.preco_diario);

  const handleVerificarMatch = () => {
    const ini = parseToISO(dataInicio);
    if (!ini) return Alert.alert('Atenção', 'Informe a data de início');

    navigation.navigate('Matching', {
      veiculo,
      origem,
      destino,
      data_inicio: ini,
      data_fim:    parseToISO(dataFim),
    });
  };

  const handleReservar = () => {
    const ini = parseToISO(dataInicio);
    const fim = parseToISO(dataFim);
    if (!ini || !fim) return Alert.alert('Atenção', 'Informe as datas de início e fim');
    if (dias <= 0)    return Alert.alert('Atenção', 'Data final deve ser após a inicial');

    navigation.navigate('BookingConfirm', {
      veiculo,
      origem,
      destino,
      data_inicio: ini,
      data_fim:    fim,
      dias,
      preco_total: precoTotal,
    });
  };

  return (
    <ScrollView style={styles.container} showsVerticalScrollIndicator={false}>
      {/* Ícone grande do tipo de veículo */}
      <View style={styles.heroBox}>
        <Text style={styles.heroIcon}>
          {veiculo.categoria === 'caminhao_b' ? '🚚' : veiculo.categoria === 'van' ? '🚐' : '🚗'}
        </Text>
        <View style={styles.heroInfo}>
          <Text style={styles.heroModelo}>{veiculo.modelo}</Text>
          <Text style={styles.heroAno}>{CATEGORIA_LABEL[veiculo.categoria] || 'Veículo'} · {veiculo.ano}</Text>
          <Text style={styles.heroPlaca}>🔖 {veiculo.placa}</Text>
        </View>
      </View>

      {/* Preço */}
      <View style={styles.precoRow}>
        <Text style={styles.preco}>R$ {parseFloat(veiculo.preco_diario).toFixed(2)}</Text>
        <Text style={styles.precoDia}>/dia</Text>
        {veiculo.avaliacao_media > 0 && (
          <Text style={styles.avaliacao}>⭐ {parseFloat(veiculo.avaliacao_media).toFixed(1)} ({veiculo.total_avaliacoes})</Text>
        )}
      </View>

      {/* Detalhes */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Detalhes</Text>
        <View style={styles.detalheGrid}>
          <DetalheItem icon="📍" label="Cidade Base"  value={veiculo.cidade_base} />
          <DetalheItem icon="📦" label="Carga Máx."   value={veiculo.capacidade_carga ? `${veiculo.capacidade_carga} kg` : 'N/A'} />
          <DetalheItem icon="👤" label="Proprietário" value={veiculo.proprietario_nome} />
          <DetalheItem icon="📞" label="Telefone"     value={veiculo.proprietario_telefone || '—'} />
        </View>
      </View>

      {/* Datas */}
      <View style={styles.section}>
        <Text style={styles.sectionTitle}>Período da reserva</Text>

        <Text style={styles.label}>Data de início (DD/MM/AAAA)</Text>
        <TextInput
          style={styles.input}
          placeholder="Ex: 15/06/2025"
          value={dataInicio}
          onChangeText={t => setDataInicio(formatarData(t))}
          keyboardType="numeric"
          maxLength={10}
          placeholderTextColor="#aaa"
        />

        <Text style={styles.label}>Data de fim (DD/MM/AAAA)</Text>
        <TextInput
          style={styles.input}
          placeholder="Ex: 17/06/2025"
          value={dataFim}
          onChangeText={t => setDataFim(formatarData(t))}
          keyboardType="numeric"
          maxLength={10}
          placeholderTextColor="#aaa"
        />

        {dias > 0 && (
          <View style={styles.resumoPreco}>
            <Text style={styles.resumoTexto}>
              {dias} dia{dias > 1 ? 's' : ''} × R$ {parseFloat(veiculo.preco_diario).toFixed(2)}
            </Text>
            <Text style={styles.resumoTotal}>Total: R$ {precoTotal.toFixed(2)}</Text>
          </View>
        )}
      </View>

      {/* Botão matching */}
      <TouchableOpacity style={styles.btnMatch} onPress={handleVerificarMatch}>
        <Text style={styles.btnMatchText}>🔗  Verificar Rotas Complementares</Text>
        <Text style={styles.btnMatchSub}>Economize até 35% com matching P2P</Text>
      </TouchableOpacity>

      {/* Botão reservar */}
      <TouchableOpacity style={styles.btnReservar} onPress={handleReservar}>
        <Text style={styles.btnReservarText}>Reservar Agora</Text>
      </TouchableOpacity>

      <View style={{ height: 40 }} />
    </ScrollView>
  );
}

function DetalheItem({ icon, label, value }) {
  return (
    <View style={styles.detalheItem}>
      <Text style={styles.detalheIcon}>{icon}</Text>
      <Text style={styles.detalheLabel}>{label}</Text>
      <Text style={styles.detalheValue}>{value}</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  container:     { flex: 1, backgroundColor: '#f9f9f9' },
  heroBox:       { backgroundColor: '#F5C518', padding: 24, flexDirection: 'row', alignItems: 'center', gap: 20 },
  heroIcon:      { fontSize: 64 },
  heroInfo:      { flex: 1 },
  heroModelo:    { fontSize: 24, fontWeight: '900', color: '#1a1a1a' },
  heroAno:       { fontSize: 14, color: '#444', marginTop: 2 },
  heroPlaca:     { fontSize: 13, color: '#555', marginTop: 4 },
  precoRow:      { flexDirection: 'row', alignItems: 'baseline', padding: 20, gap: 4 },
  preco:         { fontSize: 32, fontWeight: '900', color: '#1a1a1a' },
  precoDia:      { fontSize: 16, color: '#888' },
  avaliacao:     { marginLeft: 'auto', fontSize: 14, color: '#555' },
  section:       { backgroundColor: '#fff', margin: 12, borderRadius: 16, padding: 18, shadowColor: '#000', shadowOpacity: 0.05, shadowRadius: 6, elevation: 2 },
  sectionTitle:  { fontSize: 16, fontWeight: 'bold', color: '#1a1a1a', marginBottom: 14 },
  detalheGrid:   { gap: 10 },
  detalheItem:   { flexDirection: 'row', alignItems: 'center', gap: 10 },
  detalheIcon:   { fontSize: 18, width: 28 },
  detalheLabel:  { fontSize: 13, color: '#888', width: 100 },
  detalheValue:  { fontSize: 14, fontWeight: '600', color: '#1a1a1a', flex: 1 },
  label:         { fontSize: 13, fontWeight: '600', color: '#555', marginBottom: 6, marginTop: 12 },
  input:         { backgroundColor: '#f5f5f5', borderRadius: 10, paddingHorizontal: 14, paddingVertical: 12, fontSize: 15, color: '#1a1a1a' },
  resumoPreco:   { backgroundColor: '#fff9e6', borderRadius: 10, padding: 14, marginTop: 14 },
  resumoTexto:   { fontSize: 14, color: '#555' },
  resumoTotal:   { fontSize: 18, fontWeight: 'bold', color: '#1a1a1a', marginTop: 4 },
  btnMatch:      { backgroundColor: '#1a1a1a', margin: 12, borderRadius: 14, padding: 18, alignItems: 'center' },
  btnMatchText:  { color: '#F5C518', fontWeight: 'bold', fontSize: 16 },
  btnMatchSub:   { color: '#888', fontSize: 12, marginTop: 4 },
  btnReservar:   { backgroundColor: '#F5C518', margin: 12, borderRadius: 14, paddingVertical: 16, alignItems: 'center' },
  btnReservarText:{ fontSize: 17, fontWeight: 'bold', color: '#1a1a1a' },
});
